import styled from 'styled-components';

export const TutorCard = styled.div`
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 24px;
`;
